import { SessionAttendeeRole } from '@/queries/constants'
import SessionAttendeeQ from '@/queries/SessionAttendeeQ'
import SessionQ from '@/queries/SessionQ'
import type { Query } from '@/client/query'

export default function getZoomSpeakingMinutesSummary(session: Query): {
  totalSpeakingMinutes: number
  tutorSpeakingPercentage: number | null
} {
  const totalSpeakingSeconds =
    session(
      SessionAttendeeQ.getZoomSpeakingDurationSeconds({
        roles: [SessionAttendeeRole.Learner, SessionAttendeeRole.Tutor],
        sessionId: SessionQ.id,
      })
    ) ?? 0
  const totalSpeakingMinutes = Math.ceil(totalSpeakingSeconds / 60)

  const tutorSpeakingSeconds =
    session(
      SessionAttendeeQ.getZoomSpeakingDurationSeconds({
        roles: [SessionAttendeeRole.Tutor],
        sessionId: SessionQ.id,
      })
    ) ?? 0

  const tutorSpeakingPercentage =
    totalSpeakingSeconds === 0
      ? null
      : Math.round((tutorSpeakingSeconds / totalSpeakingSeconds) * 100)

  return { totalSpeakingMinutes, tutorSpeakingPercentage }
}
